var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.99 59.99",
    style: {
      enableBackground: "new 0 0 59.99 59.99"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.985,52c12.131,0,22-9.869,22-22s-9.869-22-22-22s-22,9.869-22,22S17.855,52,29.985,52z M29.985,10   c11.028,0,20,8.972,20,20s-8.972,20-20,20s-20-8.972-20-20S18.958,10,29.985,10z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.985,15c0.552,0,1-0.447,1-1v-2c0-0.553-0.448-1-1-1s-1,0.447-1,1v2C28.985,14.553,29.433,15,29.985,15z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.985,45c-0.552,0-1,0.447-1,1v2c0,0.553,0.448,1,1,1s1-0.447,1-1v-2C30.985,45.447,30.538,45,29.985,45z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.985,31h2c0.552,0,1-0.447,1-1s-0.448-1-1-1h-2c-0.552,0-1,0.447-1,1S45.433,31,45.985,31z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.985,29h-2c-0.552,0-1,0.447-1,1s0.448,1,1,1h2c0.552,0,1-0.447,1-1S14.538,29,13.985,29z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.985,41c0.256,0,0.512-0.098,0.707-0.293l8.274-8.274C28.561,32.785,29.246,33,29.985,33c2.206,0,4-1.794,4-4   c0-1.859-1.28-3.411-3-3.858V20c0-0.553-0.448-1-1-1s-1,0.447-1,1v5.142c-1.72,0.447-3,1.999-3,3.858   c0,0.74,0.215,1.424,0.567,2.019l-8.274,8.274c-0.391,0.391-0.391,1.023,0,1.414C18.474,40.902,18.73,41,18.985,41z M29.985,27   c1.103,0,2,0.897,2,2s-0.897,2-2,2s-2-0.897-2-2S28.882,27,29.985,27z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.069,10h7.917c0.552,0,1-0.447,1-1s-0.448-1-1-1h-5.302c4.924-3.885,10.975-6,17.302-6c15.439,0,28,12.561,28,28   c0,0.553,0.448,1,1,1s1-0.447,1-1c0-16.542-13.458-30-30-30c-6.981,0-13.643,2.408-19,6.81V1c0-0.553-0.448-1-1-1s-1,0.447-1,1v9   h0.893C9.943,10.007,10.004,10.005,10.069,10z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.805,42.229c-0.25-0.5-0.84-0.699-1.34-0.46c-0.5,0.24-0.7,0.84-0.46,1.34c0.17,0.351,0.53,0.561,0.9,0.561   c0.14,0,0.29-0.03,0.43-0.101C4.835,43.33,5.046,42.729,4.805,42.229z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.855,47.14c-0.34-0.439-0.96-0.52-1.4-0.18s-0.52,0.97-0.18,1.399c0.2,0.261,0.5,0.391,0.79,0.391   c0.22,0,0.43-0.07,0.62-0.21C8.115,48.2,8.195,47.569,7.855,47.14z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.205,44.76c-0.29-0.47-0.91-0.61-1.38-0.32c-0.47,0.301-0.61,0.91-0.32,1.38c0.19,0.301,0.52,0.471,0.85,0.471   c0.18,0,0.36-0.05,0.53-0.15C6.355,45.85,6.495,45.229,6.205,44.76z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.335,49.3c-0.4,0.38-0.41,1.01-0.03,1.41c0.19,0.21,0.46,0.31,0.72,0.31c0.25,0,0.5-0.09,0.69-0.279   c0.4-0.381,0.42-1.011,0.03-1.41C9.365,48.93,8.735,48.92,8.335,49.3z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.445,51.43c-0.36,0.42-0.31,1.05,0.11,1.41c0.19,0.16,0.42,0.24,0.65,0.24c0.28,0,0.56-0.12,0.76-0.351   c0.36-0.42,0.31-1.05-0.11-1.41C11.435,50.96,10.805,51.01,10.445,51.43z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.095,38.02c0.53-0.14,0.86-0.68,0.73-1.22c-0.14-0.53-0.68-0.86-1.22-0.72c-0.53,0.13-0.86,0.67-0.72,1.21   c0.11,0.45,0.52,0.76,0.97,0.76C1.935,38.05,2.015,38.04,2.095,38.02z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.415,35.09c0.55-0.08,0.93-0.58,0.85-1.13s-0.59-0.93-1.13-0.851c-0.55,0.08-0.93,0.591-0.85,1.131   c0.07,0.5,0.5,0.859,0.99,0.859C1.325,35.1,1.365,35.1,1.415,35.09z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.665,39.569c-0.18-0.52-0.76-0.789-1.28-0.6c-0.52,0.19-0.78,0.76-0.59,1.28c0.14,0.41,0.53,0.66,0.93,0.66   c0.12,0,0.23-0.021,0.35-0.061C3.595,40.66,3.855,40.09,3.665,39.569z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.005,32.12c0.01,0,0.03,0,0.04,0c0.55-0.021,0.98-0.49,0.96-1.04c-0.02-0.55-0.49-0.98-1.04-0.96   c-0.55,0.02-0.98,0.479-0.96,1.04C0.025,31.689,0.475,32.12,1.005,32.12z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.765,53.34c-0.32,0.45-0.2,1.07,0.25,1.39c0.18,0.12,0.37,0.17,0.57,0.17c0.32,0,0.63-0.149,0.82-0.43   c0.32-0.45,0.2-1.08-0.25-1.39C13.695,52.77,13.075,52.88,12.765,53.34z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.925,50.609V50.6c-0.41,0.38-0.44,1.01-0.06,1.42c0.2,0.21,0.47,0.32,0.74,0.32c0.24,0,0.48-0.09,0.67-0.26   c0.41-0.38,0.43-1.011,0.06-1.41C49.965,50.26,49.325,50.229,48.925,50.609z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.955,48.54c-0.37,0.41-0.33,1.04,0.08,1.41c0.19,0.17,0.43,0.25,0.66,0.25c0.28,0,0.55-0.11,0.75-0.341   c0.37-0.409,0.33-1.04-0.08-1.409C51.945,48.09,51.315,48.12,50.955,48.54z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.755,46.27c-0.32,0.45-0.22,1.08,0.23,1.4c0.18,0.13,0.38,0.189,0.58,0.189c0.32,0,0.62-0.149,0.82-0.42   c0.32-0.449,0.22-1.069-0.23-1.399C53.705,45.72,53.075,45.83,52.755,46.27z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.695,52.45c-0.44,0.33-0.53,0.96-0.2,1.399c0.19,0.271,0.49,0.4,0.8,0.4c0.21,0,0.42-0.061,0.59-0.19   c0.45-0.33,0.54-0.96,0.21-1.399C47.765,52.21,47.135,52.12,46.695,52.45z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.285,54.06c-0.47,0.29-0.63,0.9-0.34,1.37c0.18,0.32,0.52,0.49,0.86,0.49c0.17,0,0.35-0.04,0.51-0.14   c0.47-0.28,0.63-0.9,0.34-1.37C45.375,53.939,44.765,53.78,44.285,54.06z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.685,43.46c-0.48-0.271-1.09-0.101-1.37,0.38h0.01c-0.28,0.479-0.11,1.09,0.37,1.36c0.15,0.09,0.32,0.13,0.49,0.13   c0.35,0,0.69-0.181,0.87-0.5C56.335,44.35,56.165,43.74,55.685,43.46z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.935,32c-0.55-0.061-1.04,0.34-1.1,0.89c-0.06,0.55,0.34,1.04,0.89,1.101c0.04,0,0.07,0,0.11,0   c0.5,0,0.94-0.381,0.99-0.9C59.885,32.55,59.485,32.05,58.935,32z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.575,34.979c-0.54-0.12-1.07,0.23-1.18,0.771c-0.12,0.54,0.23,1.069,0.77,1.18c0.07,0.021,0.14,0.021,0.21,0.021   c0.46,0,0.88-0.32,0.97-0.79C59.465,35.62,59.115,35.09,58.575,34.979z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.905,37.899c-0.52-0.17-1.09,0.12-1.25,0.65c-0.17,0.52,0.12,1.09,0.64,1.26c0.1,0.03,0.21,0.04,0.31,0.04   c0.42,0,0.81-0.27,0.95-0.689C58.725,38.63,58.435,38.069,57.905,37.899z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.945,40.74c-0.51-0.221-1.1,0.01-1.32,0.51c-0.23,0.51,0,1.1,0.51,1.319c0.13,0.061,0.27,0.091,0.4,0.091   c0.39,0,0.75-0.23,0.92-0.601C57.675,41.55,57.445,40.96,56.945,40.74z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.735,55.42c-0.51,0.229-0.72,0.82-0.49,1.32c0.17,0.369,0.53,0.579,0.91,0.579c0.14,0,0.28-0.029,0.42-0.09   c0.5-0.229,0.72-0.83,0.48-1.33C42.825,55.399,42.235,55.18,41.735,55.42z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.765,57.51c-0.54-0.1-1.07,0.25-1.17,0.8c-0.1,0.54,0.25,1.061,0.8,1.17c0.06,0.011,0.12,0.011,0.18,0.011   c0.47,0,0.89-0.33,0.99-0.811C25.665,58.14,25.305,57.609,24.765,57.51z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.635,57.899c-0.55-0.05-1.04,0.36-1.08,0.91c-0.05,0.561,0.36,1.04,0.91,1.09c0-0.01,0-0.01,0-0.01   c0.03,0.01,0.06,0.01,0.08,0.01c0.52,0,0.96-0.399,1-0.92C28.585,58.43,28.185,57.95,27.635,57.899z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.955,56.83c-0.53-0.16-1.09,0.14-1.25,0.66c-0.15,0.529,0.14,1.09,0.67,1.25c0.1,0.029,0.2,0.04,0.29,0.04   c0.43,0,0.83-0.28,0.96-0.711C22.785,57.54,22.485,56.979,21.955,56.83z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.225,55.85c-0.51-0.21-1.09,0.03-1.3,0.54c-0.22,0.51,0.02,1.09,0.53,1.311c0.13,0.05,0.26,0.069,0.39,0.069   c0.39,0,0.76-0.229,0.92-0.609C19.975,56.649,19.735,56.06,19.225,55.85z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.415,57.79c-0.55,0.069-0.94,0.569-0.87,1.109c0.06,0.511,0.49,0.881,0.99,0.881c0.04,0,0.08,0,0.12-0.011   c0,0.011,0,0.011,0,0.011c0.55-0.07,0.94-0.57,0.87-1.12C34.465,58.109,33.965,57.72,33.415,57.79z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.046,56.5c-0.52,0.17-0.8,0.74-0.62,1.27c0.14,0.41,0.53,0.67,0.94,0.67c0.11,0,0.22-0.02,0.33-0.05   c0.52-0.18,0.8-0.75,0.62-1.27C40.135,56.59,39.565,56.319,39.046,56.5z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.265,57.29c-0.54,0.12-0.88,0.66-0.75,1.2c0.1,0.46,0.52,0.77,0.97,0.77c0.08,0,0.15,0,0.23-0.02   c0.53-0.12,0.87-0.66,0.75-1.2C37.335,57.5,36.805,57.17,36.265,57.29z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.525,57.99c-0.55,0.01-0.99,0.47-0.98,1.02c0.01,0.55,0.46,0.98,1,0.98c0.01,0,0.01,0,0.02,0   c0.55-0.011,0.99-0.46,0.98-1.021C31.535,58.42,31.075,57.979,30.525,57.99z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.615,54.6c-0.48-0.27-1.09-0.09-1.36,0.4c-0.26,0.479-0.08,1.09,0.41,1.35c0.15,0.09,0.31,0.13,0.47,0.13   c0.36,0,0.7-0.189,0.88-0.529C17.285,55.47,17.105,54.859,16.615,54.6z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.f6accd51367e3825022d1c63bae08357.svg";
export { ForwardRef as ReactComponent };